import { useEffect, useRef, useState } from 'react';
import CommonStyles from './FJAiToolsItemCommon.module.less';
import Styles from './FJComparePreview.module.less';
import classNames from 'classnames';
import FJLocalStore from '../../../../../../store/FJLocalStore';
import ArrowIcon from '../../../../../../assets/svg/community/split-arrow.svg?react';
import PropTypes from 'prop-types';
import FJUtil from '../../../../../../util/FJUtil';

const FJVideoComparePreview = props => {
    const { name, beforeUrl, afterUrl, jumpLink } = props;

    const _previewItem = useRef();
    const beforeVideoRef = useRef();
    const afterVideoRef = useRef();

    const [isHover, setIsHover] = useState(false);
    const [compareScale, setCompareScale] = useState(0.5);

    useEffect(() => {
        if (isHover) {
            beforeVideoRef.current.currentTime = 0;
            afterVideoRef.current.currentTime = 0;
            beforeVideoRef.current.play();
            afterVideoRef.current.play();
        } else {
            beforeVideoRef.current.pause();
            afterVideoRef.current.pause();
            beforeVideoRef.current.currentTime = 0;
            afterVideoRef.current.currentTime = 0;
        }
    }, [isHover]);

    const _onMouseEnter = () => {
        setIsHover(true);
    };

    const _onMouseLeave = e => {
        setIsHover(false);
        const rect = _previewItem.current.getBoundingClientRect();
        const mouseX = e.clientX;
        if (mouseX < rect.x) setCompareScale(0);
        else if (mouseX > rect.x + rect.width) setCompareScale(1);
    };

    const _onMouseMove = e => {
        if (!isHover || !_previewItem.current) return;
        e.stopPropagation();

        // 获取鼠标相对于div的位置
        const rect = _previewItem.current.getBoundingClientRect();
        const mouseX = e.clientX - rect.left;
        const scale = mouseX / rect.width;
        setCompareScale(scale);
    };

    const _onClick = () => {
        if (jumpLink) window.open(jumpLink, '_blank');
        FJUtil.eaLog('ai home ai tool page click', {
            toolName: name.replaceAll('-', ' '),
        });
    };

    const _clipPath = `inset(0px 0px 0px ${Math.round(compareScale * 100)}%)`;

    return (
        <div className={CommonStyles.itemBox}>
            <div
                ref={_previewItem}
                className={classNames(CommonStyles.previewBox, Styles.previewBox)}
                onMouseEnter={_onMouseEnter}
                onMouseLeave={_onMouseLeave}
                onMouseMove={_onMouseMove}
                onClick={_onClick}
            >
                <video ref={beforeVideoRef} src={beforeUrl} alt='' className={Styles.video} muted loop />

                <video
                    ref={afterVideoRef}
                    src={afterUrl}
                    alt=''
                    className={Styles.video}
                    muted
                    loop
                    style={{ clipPath: _clipPath }}
                />

                <div className={Styles.splitLine} style={{ left: compareScale * 100 + '%' }}>
                    <div className={Styles.arrowBox}>
                        <ArrowIcon />
                    </div>
                </div>
            </div>
            <div className={CommonStyles.itemName}>{FJLocalStore._(name)}</div>
        </div>
    );
};

FJVideoComparePreview.propTypes = {
    name: PropTypes.string.isRequired,
    beforeUrl: PropTypes.string.isRequired,
    afterUrl: PropTypes.string.isRequired,
    jumpLink: PropTypes.string.isRequired,
};

export default FJVideoComparePreview;
